'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var reactUtils = require('@chakra-ui/react-utils');
var React = require('react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var _excluded = ["children"];
var CardFooter = react.forwardRef(function (props, ref) {
  var styles = react.useStyles();
  var children = props.children,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var size = react.useBreakpointValue({
    base: 'sm',
    md: 'md'
  }, 'base');

  // Add appropriate `size` to children elements.
  var validChildren = reactUtils.getValidChildren(children).map(function (element) {
    var _element$props;
    if (element !== null && element !== void 0 && (_element$props = element.props) !== null && _element$props !== void 0 && _element$props.size) return element;
    return /*#__PURE__*/React__namespace.cloneElement(element, {
      size: size
    });
  });
  return /*#__PURE__*/React__namespace.createElement(react.chakra.footer, _extends__default["default"]({
    ref: ref
  }, rest, {
    className: utils.cx('chakra-card__footer', props.className),
    __css: styles.footer,
    children: validChildren
  }));
});
CardFooter.displayName = 'CardFooter';
exports.CardFooter = CardFooter;